import { z } from 'zod'

// Сценарии mock-данных. populated — сотрудник-админ + справочники; anonymous —
// сессии нет (GET /api/employees/me → 401), проверяет login-redirect.
export const MOCK_SCENARIOS = ['empty', 'populated', 'anonymous', 'error'] as const

const RuntimeConfigSchema = z.object({
  // Два бэкенда хаба на разных origin (00-architecture § 9.1). Имена env совпадают
  // с контрактом compose/frontend.yml (nginx-entrypoint.sh → window.__APP_CONFIG__):
  //  - API_BASE_URL — корень company-backend API (api.hub.stit.tech): companies/
  //    projects/visibility/search/tags. Дефолт '/api' (same-origin, MSW/dev).
  //  - ID_BASE_URL  — origin employee-backend + SSO (id.stit.tech): /api/employees/*
  //    и /auth/login|logout. Дефолт '' (same-origin, MSW/dev).
  API_BASE_URL: z.string().default('/api'),
  ID_BASE_URL: z.string().default(''),
  API_MODE: z.enum(['mock', 'real']).default('mock'),
  MOCK_SCENARIO: z.enum(MOCK_SCENARIOS).default('populated'),
  MOCK_DEVTOOLS: z.boolean().default(false),
  SENTRY_DSN: z.string().default(''),
  SENTRY_ENVIRONMENT: z.string().default('development'),
  RELEASE: z.string().default('dev'),
})

export type RuntimeConfig = z.infer<typeof RuntimeConfigSchema>

declare global {
  interface Window {
    __APP_CONFIG__?: unknown
  }
}

function readConfig(): RuntimeConfig {
  const env = import.meta.env as Record<string, string | undefined>
  const fromEnv = {
    API_BASE_URL: env.VITE_API_BASE_URL,
    ID_BASE_URL: env.VITE_ID_BASE_URL,
    API_MODE: env.VITE_API_MODE,
    MOCK_SCENARIO: env.VITE_MOCK_SCENARIO,
    MOCK_DEVTOOLS: env.VITE_MOCK_DEVTOOLS === '1',
  }
  const fromWindow =
    typeof window !== 'undefined' && window.__APP_CONFIG__
      ? (window.__APP_CONFIG__ as Record<string, unknown>)
      : {}
  const merged = Object.fromEntries(
    Object.entries({ ...fromEnv, ...fromWindow }).filter(([, v]) => v !== undefined),
  )
  return RuntimeConfigSchema.parse(merged)
}

export const runtimeConfig = readConfig()
